import {gql} from "@irati/utils/gql"

const ProductData = gql`
  fragment productDataFields on ProductData {
    cinemaMetadata {
      enabled
      locations
    }
    externalMetadata {
      apiCode
      denomination
      nativeID
      openValue
      reservable
      advertiserId
    }
  }
`

const fragment = gql`
  fragment fullProduct on Product {
    data {
      ...productDataFields
    }
    date
    dateUnix
    locale
    name
    supplier
    type
    uuid
    active
    currency
    provider
    vat
    acqDiscount
    externalIdentifier
    recomRetailPrice
  }
  ${ProductData}
`

export default fragment
